import { Banner } from '@procore/core-react'
import * as React from 'react'
import { useAuth0 } from '../utils/auth'
import { StyledLoginBanner } from './LoginBanner.styles'

const LOGIN_BANNER_SHOWN_KEY = 'core-docs-login-prompt-shown'

// Prompt user to log in once per session
export function LoginBanner() {
  const { isAuthenticated, loading } = useAuth0()
  const [showBanner, setShowBanner] = React.useState(false)

  React.useEffect(() => {
    if (!loading && !isAuthenticated && typeof window !== 'undefined') {
      const bannerShown = sessionStorage.getItem(LOGIN_BANNER_SHOWN_KEY)
      setShowBanner(!bannerShown)
    }
  }, [loading, isAuthenticated])

  const handleClose = () => {
    setShowBanner(false)
    sessionStorage.setItem(LOGIN_BANNER_SHOWN_KEY, 'true')
  }

  if (!showBanner) {
    return null
  }

  return (
    <StyledLoginBanner variant="attention">
      <Banner.Content>
        <Banner.Title>Log in to access more features</Banner.Title>
        <Banner.Body>
          Some content requires authentication. Please log in to access all
          features.
        </Banner.Body>
      </Banner.Content>

      <Banner.Dismiss onClick={handleClose} />
    </StyledLoginBanner>
  )
}
